import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@classify/react-core-components/styles';
import scrollToElement from '@classify/react-core-components/scrollToElement';
interface Props {
  items: Array<{
    label: string;
    targetId: string;
  }>;
  color: string;
  offset?: number;
}
const Wrapper = styled('nav')<{
  color: string;
}>(() => ({
  display: 'flex',
  flexDirection: 'row',
  position: 'relative'
}));
const Underline = styled('span')(() => ({
  content: '""',
  display: 'block',
  position: 'absolute',
  bottom: 0,
  height: 2,
  left: 0,
  right: 0,
  transition: 'left 0.3s, width 0.3s'
}));
const SectionNav = t0 => {
  const $ = _c(25);
  const {
    items,
    offset: t1,
    color
  } = t0;
  const offset = t1 === undefined ? 0 : t1;
  const [currentlyVisibleSection, setCurrentlyVisibleSection] = useState(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      left: 0,
      width: 0
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [currentActiveItemPosition, setCurrentActiveItemPosition] = useState(t2);
  let t3;
  let t4;
  if ($[1] !== items) {
    t3 = () => {
      const observerCallback = entries => {
        const intersectingEntries = entries.filter(_temp);
        if (intersectingEntries.length === 0) {
          const firstItem = items[0];
          const firstSection = firstItem ? document.getElementById(firstItem.targetId) : null;
          if (firstItem && firstSection && firstSection.getBoundingClientRect().top > 0) {
            setCurrentlyVisibleSection(firstItem.targetId);
          }
          return;
        }
        const sortedEntries = intersectingEntries.sort(_temp2);
        setCurrentlyVisibleSection(sortedEntries[0].target.id);
      };
      const observer = new IntersectionObserver(observerCallback, {
        rootMargin: "-30% 0px -70% 0px",
        threshold: 0
      });
      items.forEach(item => {
        const domElement = document.getElementById(item.targetId);
        if (domElement) {
          observer.observe(domElement);
        }
      });
      return () => {
        observer.disconnect();
      };
    };
    t4 = [items];
    $[1] = items;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[4] !== currentlyVisibleSection) {
    t5 = () => {
      const navItemElement = document.querySelector(`a[href="#${currentlyVisibleSection}"]`) as HTMLElement | null;
      if (navItemElement) {
        const {
          left,
          width
        } = navItemElement.getBoundingClientRect();
        const parentLeft = navItemElement.parentElement?.getBoundingClientRect().left || 0;
        setCurrentActiveItemPosition({
          left: left - parentLeft,
          width
        });
      }
    };
    t6 = [currentlyVisibleSection];
    $[4] = currentlyVisibleSection;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] !== offset) {
    t7 = (event, targetId) => {
      event.preventDefault();
      const element = document.getElementById(targetId);
      scrollToElement(element, {
        offset
      });
    };
    $[7] = offset;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleClick = t7;
  let t8;
  if ($[9] !== color || $[10] !== currentlyVisibleSection || $[11] !== handleClick || $[12] !== items) {
    let t9;
    if ($[14] !== color || $[15] !== currentlyVisibleSection || $[16] !== handleClick) {
      t9 = t10 => {
        const {
          targetId: targetId_0,
          label
        } = t10;
        const isActive = currentlyVisibleSection === targetId_0;
        return <ButtonBase key={targetId_0} color={color} onClick={event_0 => handleClick(event_0, targetId_0)} href={`#${targetId_0}`} component="a" sx={{
          py: 2,
          px: 1.5,
          ...(isActive && {
            fontWeight: "bold",
            color
          }),
          "&:hover": {
            color
          },
          textAlign: {
            xs: "center",
            sm: "left"
          }
        }}>{label}</ButtonBase>;
      };
      $[14] = color;
      $[15] = currentlyVisibleSection;
      $[16] = handleClick;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    t8 = items.map(t9);
    $[9] = color;
    $[10] = currentlyVisibleSection;
    $[11] = handleClick;
    $[12] = items;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[18] !== color || $[19] !== currentActiveItemPosition) {
    t9 = <Underline sx={{
      left: currentActiveItemPosition.left,
      width: currentActiveItemPosition.width,
      backgroundColor: color,
      currentActiveItemPosition
    }} />;
    $[18] = color;
    $[19] = currentActiveItemPosition;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== color || $[22] !== t8 || $[23] !== t9) {
    t10 = <Wrapper color={color}>{t8}{t9}</Wrapper>;
    $[21] = color;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export default SectionNav;
function _temp(entry) {
  return entry.isIntersecting === true;
}
function _temp2(a, b) {
  return a.boundingClientRect.top - b.boundingClientRect.top;
}